import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { EMPTY_ILLUSTRATIONS, EmptyContainer } from '@thinknet-gmbh/platform-common-ui';

import { DatevDataTypesEnum, PayrollAccountingTypeEnum } from '@thinknet-gmbh/platform-common';

import { useGetAllPlatformCompanies } from 'src/hooks/companies/get-all-platform-companies.hook';

import { generateYearsOptions } from '../payroll-accounting.helpers';

import { PayrollAccountingDatevFilters } from './components/payroll-accounting-datev-filters';
import { PayrollAccountingDatevList } from './components/payroll-accounting-datev-list';

import { IPayrollAccountingFilters } from '../payroll-accounting.interfaces';

import { MainWrapper } from './payroll-accounting-datev.styles';

const MIN_YEAR = 1900;

interface IPayrollAccountingListProps {
  settingId?: string;
  currentCompanyId?: string;
}

const PayrollAccountingDatev = ({ currentCompanyId, settingId }: IPayrollAccountingListProps) => {
  const { t } = useTranslation(['common', 'payrollAccounting']);

  const currentYear = moment().year();
  const [filters, setFilters] = useState<IPayrollAccountingFilters>({
    year: currentYear,
    dataType: DatevDataTypesEnum.basedata,
  });

  const { companies } = useGetAllPlatformCompanies();

  const handleFilterChange = (filter: IPayrollAccountingFilters) => {
    setFilters(prev => ({ ...prev, ...filter }));
  };

  const yearsOptions = generateYearsOptions(currentYear, MIN_YEAR);

  const companiesOptions = companies?.map(({ _id, name }: { _id: string; name: string }) => ({
    value: name,
    key: _id,
  }));

  const isFilerComplete =
    filters?.companyId && filters?.datevNumberId && filters?.year && currentCompanyId && settingId;

  return (
    <MainWrapper>
      <PayrollAccountingDatevFilters
        filters={filters}
        minYear={MIN_YEAR}
        maxYear={currentYear}
        yearsOptions={yearsOptions}
        handleFilterChange={handleFilterChange}
        companiesOptions={companiesOptions}
      />

      <Fragment>
        {isFilerComplete ? (
          <PayrollAccountingDatevList
            filter={{
              ...filters,
              payrollAccountingSettingId: settingId,
              parentCompanyId: currentCompanyId,
              type: PayrollAccountingTypeEnum.DATEV,
            }}
          />
        ) : (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('common:emptyContainer.emptyTitle')}
            contentText={t('payrollAccounting:emptyContainer.noDataSubtitle')}
          />
        )}
      </Fragment>
    </MainWrapper>
  );
};

export default PayrollAccountingDatev;
